export class FileFactory {
  constructor(instance) {
    this.instance = instance;
  }

  sendFile(data) {
    const formData = new FormData();
    formData.append('file', data?.file);
    formData.append('description', data?.description);

    if (data.refId) formData.append('refId', data?.refId);
    if (data.refType) formData.append('refType', data?.refType);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.post(`/v1/files/`, formData, config);
  }

  sendFileCollaborator(colaboradorId, data) {
    const formData = new FormData();
    formData.append('file', data?.file);
    formData.append('description', data?.description);

    if (data.refId) formData.append('refId', data?.refId);
    if (data.refType) formData.append('refType', data?.refType);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.post(
      `/v1/cad-colaboradores/${colaboradorId}/anexos`,
      formData,
      config,
    );
  }

  sendDocument(data) {
    const formData = new FormData();
    formData.append('file', data?.file);
    formData.append('description', data?.description);

    if (data?.tags?.length > 0) formData.append('tags', data?.tags);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.post(`/v1/files/attachments`, formData, config);
  }

  updateFile(data) {
    const formData = new FormData();
    formData.append('file', data?.file);
    formData.append('description', data?.description);

    if (data.refId) formData.append('refId', data?.refId);
    if (data.refType) formData.append('refType', data?.refType);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.put(`/v1/files/`, formData, config);
  }

  deleteFile(data) {
    return this.instance.post(`/v1/files/remove`, data);
  }

  deleteFileById(id) {
    return this.instance.delete(`/v1/files/${id}`);
  }

  downloadFile(data) {
    return this.instance.post(`/v1/files/download`, data, {
      responseType: 'blob',
    });
  }

  listAttachments(filter) {
    const filtredParams = filter ? { ...filter } : {};

    if (filtredParams.initial || filtredParams.initial !== undefined)
      delete filtredParams.initial;

    return this.instance.get('/v1/files/attachments', {
      params: filtredParams,
    });
  }

  showAttachments(id) {
    return this.instance.get(`/v1/files/attachments/${id}`);
  }

  removeDocument(id) {
    return this.instance.delete(`/v1/files/attachments/${id}`);
  }

  updateDocument(id, data) {
    return this.instance.put(`/v1/files/attachments/${id}`, data);
  }
}

export default FileFactory;
